var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v("Librería CPT")])])],1),_c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"items":_vm.libCie10s,"headers":_vm.headers}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }